"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./accommodationPriceHistoryDto");
class SaveAccommodationTypePriceHistoryDto {
}
exports.SaveAccommodationTypePriceHistoryDto = SaveAccommodationTypePriceHistoryDto;
